
const API_BASE_URL = "https://squeff.com.ar/pruebas/api/api/";

const BASE_URL_QR = "http://www.squeff.com.ar/productos.php?pid";

const RUTAPRODUCTOSIMAGENES = "https://squeff.com.ar/pruebas/api/api/uploads/imagenesproductos/";


const NOMBRECARTA = "carta.pdf";

const RUTACARTAPDF =  API_BASE_URL + "uploads/pdfs/"+NOMBRECARTA;

const TIEMPOEXPIRACIONCOOKIEENMINUTOS = 60; //minutos



const COLORSISTEMA = "#071c44" 
const ICON_COLOR = "#a9b9a6";//FEFE02
const ICON_COLOR_PEOPLE = "#70b86a";//
const DRAWER_BACKGROUND_COLOR = "#FBED55";


const LOGIN = "login.php";
const LOGOUT = "logout.php";
const USERACTUALIZAR = "userActualizar.php";
const SIGIN = "register.php";
const USERLIST = "userlist.php";

const PRODUCTOALTA = "productoalta.php";
const PRODUCTOELIMINAR = "productoeliminar.php";
const PRODUCTOEDITAR = "productoeditar.php";
const PRODUCTOSLISTS = "productoslistar.php";
const PRODUCTOFOTOS = "productogetfotos.php";
const ELIMINARFOTO = "productoeliminarfoto.php";

const PEDIDOSLISTS = "pedidoslistar.php";
const PEDIDOSDETALLESVER = "pedidosdetallever.php";

const RUBROSLISTAR = "rubroslistar.php";
const ALTACARTAPDF = "carta.php"

const PRECIOENVIO = "envioget.php";
const PRECIOENVIOALTA = "envioalta.php";

const SUCURSALESLISTAR = "sucursaleslistar.php";
const SUCURSALACTUALIZAR = "sucursalactualizar.php";
const SUCURSALACTUALIZARFECHACIERRE = "sucursalactualizarfechacierre.php";

const USUARIOACCION = "usuarioaccion.php";
const USUARIOACCIONLISTAR = "usuarioaccioneslistar.php";

const CUPONESLISTAR = "cuponeslistar.php";
const CUPONESACTUALIZAR = "cuponesactualizar.php";
const CUPONESAGREGAR = "cuponesagregar.php";

const FECHAHORA = "getfechahora.php";

const LOGERRORINSERT = "logerror.php";
const ERRORESLIST = "erroreslistar.php";
const VENTASESTADISTICAS = "ventasestadisticas.php";

const AUDITORIA = "auditoria.php";
const AUDITORIALISTAR = "auditorialistar.php";
const VENTASLISTAR = "ventaslistar.php";
const VENTAALTA = "ventaalta.php";
const VENTADETALLEVER = "ventadetallever.php";
const VENTACANCELAR = "ventacancelar.php";

const FACTURACION_GET = "facturacionget.php";
const FACTURACION_SAVE = "facturacionguardar.php";
const FACTURACION_ESTADO = "facturacionestado.php";
const FACTURACION_EMITIR = "facturacionemitir.php";
const FACTURACION_TEST = "facturaciontest.php";

const MESAS = "mesas.php";
const PEDIDO_ESTADO = "pedidoestado.php";

export { API_BASE_URL, LOGIN, LOGOUT, SIGIN, USERACTUALIZAR, USERLIST, PRODUCTOALTA, PRODUCTOSLISTS, 
    RUTAPRODUCTOSIMAGENES, PRODUCTOEDITAR, PRODUCTOFOTOS, ELIMINARFOTO, RUBROSLISTAR, PEDIDOSLISTS,
    PEDIDOSDETALLESVER, PRODUCTOELIMINAR, RUTACARTAPDF, ALTACARTAPDF,
    PRECIOENVIO, PRECIOENVIOALTA, SUCURSALESLISTAR, SUCURSALACTUALIZAR, SUCURSALACTUALIZARFECHACIERRE, 
    USUARIOACCION,USUARIOACCIONLISTAR,ERRORESLIST,
    CUPONESLISTAR,CUPONESACTUALIZAR, CUPONESAGREGAR,
    FECHAHORA, LOGERRORINSERT, AUDITORIA, AUDITORIALISTAR, BASE_URL_QR, TIEMPOEXPIRACIONCOOKIEENMINUTOS,
    VENTASLISTAR, VENTAALTA, VENTADETALLEVER, VENTACANCELAR, VENTASESTADISTICAS, COLORSISTEMA, ICON_COLOR, ICON_COLOR_PEOPLE, DRAWER_BACKGROUND_COLOR,
   FACTURACION_GET, FACTURACION_SAVE, FACTURACION_ESTADO, FACTURACION_EMITIR, FACTURACION_TEST, MESAS, PEDIDO_ESTADO};